<div class="container-fluid">
  <div class="row mrtop p-2">
    <div class="col-md-12">
      <div class="breadcrumb-title border-0 d-flex align-items-center">
        <a class="me-3" routerLink="/applicationlist"><i class="bx bx-arrow-back"></i></a>

        <img [src]="getDocThumbnail(applicationForm.data['logo'])" alt="Image Preview" class="rounded-circle"
          style="width: 30px; height: 30px; object-fit: cover" />

        <span class="ms-2" *ngIf="form.list && form.list.length > 0">
          {{ applicationForm.data["name"] }}
        </span>

        <span class="text-muted p-1 ms-2">/</span>

        <img height="25" src="assets/images/api-icons.png" />
        <span class="ms-2"> Migration</span>
      </div>
    </div>
  </div>

  <div class="col-md-12">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-auto col-xl-5">
            <div class="card">
              <div class="card-body half-screen">
                <div class="row">
                  <div class="col col-12">
                    <button class="btn btn-sm btn-outline-primary app-btn d-flex align-items-center"
                      title="Create Migration" (click)="createMigration()">
                      <i class="fa fa-plus me-2"></i> Create Migration
                    </button>
                  </div>

                  <div class="col col-12">
                    <p *ngIf="form['error'] == false && form['message']">
                      <app-ncs-alert [message]="form['message']" type="success" />
                    </p>
                    <p *ngIf="form['error'] == true && form['message']">
                      <app-ncs-alert [message]="form['message']" type="danger" />
                    </p>
                  </div>

                  <div class="col col-12">
                    <table class="table">
                      <thead class="table-light">
                        <tr>
                          <th>S.No.</th>
                          <th>Name</th>
                          <th>Status</th>
                          <th>Action</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr *ngFor="let e of form.list; let i = index">
                          <td>{{ pageIndex(i) }}</td>
                          <td>{{ e.name }}</td>
                          <td>{{ e.status }}</td>
                          <td>
                            <button class="btn btn-sm btn-outline-primary p-0 px-2 me-2" title="Role"
                              (click)="setSchema(e)">
                              View
                            </button>

                            <button *ngIf="e.status != 'apply'" class="btn btn-sm btn-outline-primary p-0 px-2 me-2"
                              title="Apply Migration" (click)="applyMigration(e)">
                              Apply
                            </button>

                            <button *ngIf="e.status == 'apply'" class="btn btn-sm btn-outline-primary p-0 px-2 me-2"
                              title="Apply Rollback" (click)="applyRollback(e)">
                              Rollback
                            </button>

                            <button class="btn btn-sm btn-outline-primary p-0 px-2 me-2" title="compare"
                              data-bs-toggle="modal" data-bs-target="#compareModal" (click)="setSchema(e)">
                              compare
                            </button>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-auto col-xl-7">
            <div class="card">
              <div class="card-header">Schema</div>
              <div class="card-body">
                <div class="json-container">
                  <ngx-json-viewer *ngIf="schema" [json]="schema" [expanded]="false"></ngx-json-viewer>
                </div>
              </div>
            </div>

            <div class="card">
              <div class="card-header">Changes Log</div>
              <div class="card-body">
                <div class="json-container">
                  <ngx-json-viewer *ngIf="changeLog" [json]="changeLog" [expanded]="false"></ngx-json-viewer>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- data entry form -->
<div class="modal fade" id="compareModal" tabindex="-1" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">
          <img [src]="getDocThumbnail(applicationForm.data['logo'])" alt="Image Preview" class="rounded-circle"
            style="width: 30px; height: 30px; object-fit: cover" />

          <span class="ms-2" *ngIf="form.list && form.list.length > 0">
            {{ applicationForm.data["name"] }}
          </span>
        </h5>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" title="Close"></button>
      </div>

      <div class="modal-body">
        <div class="row">
          <label for="compareto" class="col col-form-label col-auto">
            Compare to :
          </label>
          <div class="col col-auto">
            <select class="form-select" id="compareto" name="compareto" [(ngModel)]="compareToValue"
              (change)="onSelectChange()">
              <option selected>--Select--</option>
              <option *ngFor="let e of form.list" [value]="e.id">
                {{ e.name }}
              </option>
            </select>
          </div>

          <button type="button" class="col col-auto btn btn-outline-primary">
            Start
          </button>
        </div>
        <div class="row">
          <app-json-diff-viewer *ngIf="compareObject" [leftJson]="compareObject?.schema"
            [rightJson]="this.schema"></app-json-diff-viewer>
        </div>
      </div>
    </div>
  </div>
</div>
